import { render, staticRenderFns } from "./PanelNoveltyBoxes.vue?vue&type=template&id=ef1c4ec8&"
import script from "./PanelNoveltyBoxes.vue?vue&type=script&lang=js&"
export * from "./PanelNoveltyBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef1c4ec8')) {
      api.createRecord('ef1c4ec8', component.options)
    } else {
      api.reload('ef1c4ec8', component.options)
    }
    module.hot.accept("./PanelNoveltyBoxes.vue?vue&type=template&id=ef1c4ec8&", function () {
      api.rerender('ef1c4ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelNoveltyBoxes.vue"
export default component.exports